<ng-content select="[toolbar-title]"></ng-content>
<div id="toolbar-wrapper">
    <div id="toolbar-title">
        @if (title || !showSelectionToolbar) {
            <pf-text table-name type="primary" bold>
                {{ title }}
            </pf-text>
        }
        @if (showAdvancedFilterButton) {
            <pf-filter-button></pf-filter-button>
        }
        @if (showClearFilters) {
            <pf-button
                class="table-toolbar-btn"
                buttonType="clear"
                data-pf-handle="clear-filters"
                title="Clear Filter(s)"
                (click)="resetClicked()"
                [disabled]="disableClearFilters">
                <span class="table-toolbar-btn-text">Clear Filter(s)</span>
            </pf-button>
        }
        @if (tableService.queryParams?.serverRendered) {
            <div
                table-name
                id="table-reset-toolbar"
                [attr.title]="
                    'Refresh Table. Last updated on ' +
                    (tableService.tableState.lastUpdated | date: 'medium')
                ">
                <pf-button
                    class="table-toolbar-btn"
                    buttonType="refresh"
                    (click)="refreshTable.emit()"
                    ><span class="table-toolbar-btn-text">Refresh</span>
                </pf-button>
            </div>
        }
        <div table-name id="table-row-stats">
            @if ((tableService.selectedRowCount$ | async) === 0) {
                <span>{{ tableService.tableState.total }}&nbsp;total</span>
            }
            @if (showSelectionToolbar) {
                <div table-name id="table-selection-toolbar">
                    @if (
                        tableService.selectedRowCount$ | async;
                        as selectedRowCount
                    ) {
                        @if (selectedRowCount > 0) {
                            <span
                                >{{ selectedRowCount }} selected of
                                {{ tableService.tableState.total }}</span
                            >
                        }
                    }
                    <ng-content select="[selection-toolbar]"></ng-content>
                </div>
            }
        </div>
    </div>
    <div toolbar-actions>
        <div id="table-toolbar-left">
            <ng-content select="[toolbar-left]"></ng-content>
        </div>
        <ng-content select="[toolbar-right]"></ng-content>
    </div>
</div>
@if (showSearch) {
    <pf-text-search-filter
        [ngStyle]="{ width: '340px' }"
        [filter]="{
            name: 'Search',
            filterKey: 'Search',
            filterType: 'text'
        }"
        [displayLabel]="false"
        [instantSearch]="true"
        (filterSearch)="tableSearch.emit($event)"></pf-text-search-filter>
}
